import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";
import useChangeStatusAction from "@beeldit/ecommerce/orders/actions/change-status/useChangeStatusAction";

function OrdersPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { prepareChangeStatusFunction, actionTemplate: changeStatusTemplate } =
    useChangeStatusAction(indexFunction);

  const { detailsFunction } = useDetailsAction(0);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        indexFunction,
        detailsFunction,
        prepareChangeStatusFunction,
        /**newActionsTableConfig**/
      }),
    [indexFunction, detailsFunction, prepareChangeStatusFunction]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>{t("orders")}</Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {changeStatusTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default OrdersPage;
